export default __webpack_public_path__ + "static/cafe_36014-084c9421ce81a67b9b6bc657f3b0c7ea.png";